import { IDocumentSectionTypeMinimal } from "@/api";
import { Chip, Stack, Typography } from "@mui/material";

interface IProps {
    documentSectionTypes: IDocumentSectionTypeMinimal[];
}

export const DocumentSectionTypesCell = ({ documentSectionTypes }: IProps) => {
    return (
        <Stack direction={"row"} flexWrap={"wrap"} gap={1}>
            {/* Document Section Type Chips */}
            {documentSectionTypes.map(({ name }, index) => (
                <Chip
                    key={`documentSectionType-${name}-${index}`}
                    label={name}
                    size={"small"}
                    color={"tertiary"}
                />
            ))}

            {/*  Zero State */}
            {documentSectionTypes.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                    -
                </Typography>
            )}
        </Stack>
    );
};
